export default "__VITE_ASSET__bf1520a5__"